export const AppPrint = `<!DOCTYPE html>
      <html>
        <head>
          <style>
            * {
              font-size: 12px;
              box-sizing: border-box;
            }

            /* 🔥 Use 76mm instead of 80mm for safe printable area */
            html, body {
              width: 73mm;
              margin: 0;
              padding: 3px; /* Add some padding to prevent content from being cut off */
            }

            /* 🔥 Important for Puppeteer */
            @page {
              size: 73mm auto;
              margin: 0;
            }

            .page {
              width: 73mm;
              margin: 0;
              padding: 4px; /* Add some padding to prevent content from being cut off */
            }

            .receipt-content {
              width: 100%;
              padding: 4px;
              font-family: Arial, sans-serif;
            }

            /* ---------- TABLE ---------- */

            table {
              width: 100%;
              border-collapse: collapse;
              table-layout: fixed; /* Prevents overflow */
            }

            th, td {
              padding: 3px 2px;
              font-size: 12px;
              overflow: hidden;
            }

            /* Column Width Distribution (Safe for 76mm) */
            .col-no    { width: 6%;  text-align: left; }
            .col-name  { width: 38%; word-break: break-word; }
            .col-qty   { width: 12%; text-align: center; }
            .col-price { width: 22%; text-align: right; }
            .col-total { width: 22%; text-align: right; }

            /* Allow only product name to wrap */
            .col-name {
              white-space: normal;
            }

            /* Keep numbers in one line */
            .col-price,
            .col-total,
            .col-qty {
              white-space: nowrap;
            }

            /* Optional copy break */
            .copy-break {
              page-break-after: always;
            }
              div, p, table, tr, td, img {
              page-break-inside: avoid;
              break-inside: avoid;
            }

            body {
              page-break-after: avoid;
            }
              .copy-break {
              page-break-after: always;
            }
      </style>
    </head>`;

export const SystemPrint = `<!DOCTYPE html>
  <html>
    <head>
      <style>
        * {
          font-size: 12px;
          margin: 1;
          box-sizing: border-box;
        }

        body {
          margin: 0;
          padding: 0;
        }

        @page {
          size: auto;
          margin: 5mm;
        }

        .page {
          width: auto !important;
          margin: 0;
          padding: 0;
        }
            .col-price,
            .col-total,
            .col-qty {
              white-space: nowrap;
            }

        .receipt-content {
          width: 80%;
          padding: 5px;
        }

        div, p, table, tr, td, img {
              page-break-inside: avoid;
              break-inside: avoid;
            }

        body {
              page-break-after: avoid;
            }
        /* Important for 2 copy printing */
            .copy-break {
              page-break-after: always;
            }
      </style>
    </head>
    `;

export const DailySummeryPrint = `<!DOCTYPE html>
      <html>
        <head>
          <meta charset="utf-8" />
          <title>Daily Summary</title>
          <style>
            * {
              font-size: 12px;
              box-sizing: border-box;
            }

            /* 🔥 Use 73mm instead of 80mm for safe printable area */
            html, body {
              width: 73mm;
              margin: 0;
              padding: 3px; /* Add some padding to prevent content from being cut off */
            }

            /* 🔥 Important for Puppeteer */
            @page {
              size: 73mm auto;
              margin: 0;
            }

            .page {
              width: 73mm;
              margin: 0;
              padding: 4px; /* Add some padding to prevent content from being cut off */
            }

            .receipt {
              width: 100%;
              font-family: 'Courier New', monospace;
              font-size: 12px;
              color: #000;
              margin: 0 auto;
              padding: 4px;
            }

            .center { text-align: center; }
            .bold { font-weight: bold; }
            .text-lg { font-size: 16px; }
            .small { font-size: 10px; }

            .dashed-line {
              border-top: 1px dashed #000;
              margin: 1px 0;
            }

            .section-title {
              font-weight: bold;
              margin-top: 4px;
              text-transform: uppercase;
            }

            .row {
              display: flex;
              justify-content: space-between;
              padding: 1px 0;
            }

            /* Optional copy break */
            .copy-break {
              page-break-after: always;
            }

            div, p, table, tr, td, img {
              page-break-inside: avoid;
              break-inside: avoid;
            }

            body {
              page-break-after: avoid;
            }
      </style>
    </head>`;
